module.exports = __webpack_public_path__ + "img/Completed.7e588f5b.png";